<template>
    <div class="top-tab-main">
        <div
            v-for="(item, index) in tabList"
            :key="item.value"
            :class="['tabs__header-item', { 'is-active': currentTab == item.value }]"
            @click="handleTabChange(item, index, $event)"
        >
            <el-checkbox
                v-model="item.checked"
                @click.native="(event) => event.stopPropagation()"
                @change="handleTabCheckChange(item, index, $event)"
            ></el-checkbox>
            <span style="margin-left: 4px;">{{ $t(item.label)  }}</span>
        </div>
    </div>
</template>
<script>
export default {
    mixins: [],
    components: {},
    props: {
        currentTab: {
            type: String,
            default: 'grid',
        },
        tabList: {
            type: Array,
            default: () => [], // [{label: '网格', value: 'grid', icon: '',checked: true}]
        },
    },
    data() {
        return {};
    },
    computed: {},
    methods: {
        /**
         * 处理标签页切换事件
         *
         * @param tab 标签页对象
         * @param index 标签页索引
         */
        handleTabChange(tab, index, event) {
            console.log('handleTabChange', tab, index, event);
            this.$emit('changeTypeControl', tab.value);
        },

        handleTabCheckChange(tab, index, checked) {
            const checkedItems = this.tabList.filter((item) => item.checked);
            const checkedValues = checkedItems.map((item) => item.value);
            this.$emit('changeDataControl', checkedValues);
        },
    },
    created() {},
    mounted() {},
};
</script>
<style lang="scss" scoped>
$topTitleHeight: 65px;
$topButtonHeight: 36px;
$tapItemHeight: 32px;
$colorLightBlue: #49f0fd;

.top-tab-main {
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 30px;
    width: 80%;
    text-align: center;

    .tabs {
        position: relative;

        &__header-item {
            display: inline-flex;
            box-sizing: border-box;
            align-items: center;
            justify-content: center;
            text-align: center;
            cursor: pointer;
            width: 150px;
            height: 44px;
            color: #fff;
            margin-right: 8px;
            background: url('./img/Control_bg.png') no-repeat 100% 100%;
            padding: 0 10px;
            // border: 1px red solid;
            letter-spacing: 1px;

            &.is-active {
                color: #000000;
                background: url('./img/Control_bg_active.png') no-repeat 100% 100%;
            }
        }

        .tab-content {
            position: relative;
            height: calc(100% - #{$tapItemHeight} - 16px);
        }

        .tab-scrollbar {
            $searchHeight: 32px;
            height: calc(100% - #{$searchHeight});
        }

        .tab-scrollbar-2 {
            $searchHeight: 72px;
            $pageHeight: 30px;
            height: calc(100% - #{$searchHeight} - #{$pageHeight});
        }

        .tab-scrollbar-3 {
            $searchHeight: 112px;
            $pageHeight: 30px;
            height: calc(100% - #{$searchHeight} - #{$pageHeight});
        }

        ::v-deep {
            .tab-scrollbar,
            .tab-scrollbar-2,
            .tab-scrollbar-3 {
                .el-scrollbar__wrap {
                    overflow-x: hidden;
                }

                .el-scrollbar__thumb {
                    position: relative;

                    &::before {
                        content: '';
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        right: 0px;
                        bottom: 0px;
                        background: linear-gradient(
                            to bottom,
                            rgba(73, 240, 253, 1),
                            rgba(73, 240, 253, 0.4),
                            rgba(73, 240, 253, 0.4),
                            rgba(73, 240, 253, 1)
                        );
                        border-radius: inherit;
                        z-index: -1;
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        top: 1px;
                        left: 1px;
                        right: 1px;
                        bottom: 1px;
                        background: rgba(7, 17, 80, 0.8);
                        border-radius: inherit;
                        z-index: 1;
                    }
                }
            }
        }

        ::v-deep .el-collapse {
            border-top: none !important;
            border-bottom: none !important;

            &-item {
                &__header {
                    color: #ffffff;
                    background-color: transparent;
                    border-bottom: none !important;
                    height: 32px;
                    line-height: 32px;
                }

                &__wrap {
                    background-color: transparent;
                    border-bottom: none;
                }

                &__arrow {
                    color: #49f0fd;
                }

                &__content {
                    color: #ffffff;
                    padding-bottom: 12px;
                }
            }
        }

        .list-item {
            display: flex;
            box-sizing: border-box;
            align-items: center;
        }

        .collapse-list-item,
        .list-item {
            padding: 6px 8px;
            background: #112d7b;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #1a47a4;
            font-size: 14px;

            &:not(:last-child) {
                margin-bottom: 8px;
            }

            &:hover,
            &.is-active {
                background: #1a47a4;
            }

            .view-text {
                color: $colorLightBlue;
                cursor: pointer;
            }

            .time-text {
                color: rgba(255, 255, 255, 0.6);
                font-size: 12px;
            }
        }

        .list-item__checkbox {
            display: flex;
            box-sizing: border-box;
            align-items: center;
            color: rgba(255, 255, 255, 0.9);
        }

        .list-item {
            &__title {
                color: rgba(255, 255, 255, 0.9);
            }

            &__time {
                color: #a1a1a1;
            }
        }
    }
}
</style>
